import { render } from "./Speed175.vue?vue&type=template&id=4a315d46"
import script from "./Speed175.vue?vue&type=script&lang=js"
export * from "./Speed175.vue?vue&type=script&lang=js"
script.render = render

export default script